module.exports = __webpack_public_path__ + "media/img/help_center/Student_Test_02-096307a7ffd2f81b6681e631b510b5cc.jpg";